export default "__VITE_PUBLIC_ASSET__c70badb6__"